package org.example.project.engineslot

import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.service.LoginService
import org.example.project.utils.All

private val slotUserJson = Json {
    ignoreUnknownKeys = true
    encodeDefaults = false
}

private fun slotUserApiPart(value: String): String =
    js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String

private fun slotCurrentFirmenId(): String =
    LoginService.getUser()?.firmenId.orEmpty().trim()

suspend fun loadSlotCompanyUsers(): List<All> {
    val firmenId = slotCurrentFirmenId()
    if (firmenId.isBlank()) return emptyList()
    val raw = runCatching {
        LumaticaApiManager.call("userverwaltung/company-users/${slotUserApiPart(firmenId)}")
    }.getOrDefault("")
    if (raw.isBlank()) return emptyList()
    return runCatching {
        slotUserJson.decodeFromString(ListSerializer(All.AllNames.serializer()), raw)
    }.getOrDefault(emptyList())
}

suspend fun loadSlotVisibleRoles(): List<All> {
    val userId = LoginService.getId()
    val firmenId = slotCurrentFirmenId()
    if (userId.isBlank()) return emptyList()
    val raw = runCatching {
        LumaticaApiManager.call("rollenverwaltung/user/${slotUserApiPart(userId)}/${slotUserApiPart(firmenId)}")
    }.getOrDefault("")
    if (raw.isBlank()) return emptyList()
    return runCatching {
        slotUserJson.decodeFromString(ListSerializer(All.AllNames.serializer()), raw)
    }.getOrDefault(emptyList())
}
